import classNames from 'classnames'

import { CLICK_CODE } from '@local/utils'

import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import UIBookmarkButton from '@web/ui/components/BookmarkButton/UIBookmarkButton'
import FunctionButton from '@web/ui/components/FunctionButton'
import { BookingPrimitive } from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/DailyBriefingSection.type'

import styles from './DailyBriefingTitle.module.scss'

interface DailyBriefingTitleProps {
  booking: BookingPrimitive
  bookingDateTime: string
  handleClickPhone: () => void
  isAvailableBookmark?: boolean
  isBookmarked?: boolean
  openBookmarkModal?: () => void
}
export default function DailyBriefingTitle({
  booking,
  bookingDateTime,
  handleClickPhone,
  isAvailableBookmark,
  isBookmarked,
  openBookmarkModal,
}: DailyBriefingTitleProps) {
  const { isMobile } = useGlobalStaticStateContext()
  const name = booking.placeSummary.name ? booking.placeSummary.name : booking.businessName

  return (
    <div className={styles.tit_area}>
      <div className={styles.tit_inner}>
        <strong className={styles.name}>{name}</strong>
        <div className={classNames(styles.time, { [styles.type_used]: booking.isCompleted })}>
          {booking.isCompleted ? '이용완료' : bookingDateTime}
        </div>
      </div>
      <div className={styles.function_btn_area}>
        {isMobile && booking.placeSummary.phone && (
          <FunctionButton
            type="CALL"
            hideButtonName
            onClick={handleClickPhone}
            clickCode={CLICK_CODE['mydaily.call']}
          />
        )}
        {isAvailableBookmark && (
          <UIBookmarkButton
            isBookmarked={isBookmarked}
            onClickBookmark={openBookmarkModal}
            bookmarkingClickCode={CLICK_CODE['mydaily.save']}
            unbookmarkingClickCode={CLICK_CODE['mydaily.unsave']}
            buttonClassName={styles.btn}
          />
        )}
      </div>
    </div>
  )
}
